import { render, staticRenderFns } from "./SettingsTaxRateWidget.vue?vue&type=template&id=f2d67a4c&"
import script from "./SettingsTaxRateWidget.vue?vue&type=script&lang=js&"
export * from "./SettingsTaxRateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports